/**
 * Created by tong on 2018/1/23.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Input, InputNumber, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import './invoice.css';
import {
    getProductList2, setProductUp, setProductUp4, setProductUp5, goNext, newPurchaseUnit,
    addTrace
} from '../../service/invoiceManagement';
import {Store, Actions} from './store';

class invoiceStaging extends Reflux.Component {
    constructor(props) {
        super(props);
        const d = new Date();
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.defaultIndex = '';
        this.defaultOrgId = null;
        this.defaultOrgType = null;
        this.defaultDate = d.format('yyyy-MM-dd');
        this.state = {
            opts: ['开票暂存单'],
            key: 0,
            selectedRowKeys: [],
            selectedRows: [],
            choseAmount: 0,
            rows: [],
            total: 1,
            searchObj: {
                name: '',
                // category: [],
                // active: '',
                // startDate: d.format('yyyy-MM-dd'),
                // endDate: d.format('yyyy-MM-dd'),
                crStartDate: '',
                crEndDate: '',
                orderStartDate: '',
                orderEndDate: '',
                salesUnitId: '',
                s: 10,
                p: 1,
                // itemNum:'',
                // itemDesc:'',
                // deliveryId:'',
                // orderNumber:'',
                // lineId:'',
            },
            // categoryData: [],
            button_limits_end: {},
            unitList: [],
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.removeChange = this.removeChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.rowOnChange = this.rowOnChange.bind(this);
        this.rowOnChange2 = this.rowOnChange2.bind(this);
        this.addTrace = this.addTrace.bind(this);
    }

    /*返回*/
    backHandle() {
        window.history.go(-1);
    }

    /*选择*/
    onSelectChange = (selectedRowKeys, selectedRows) => {

        let choseAmount = 0;
        selectedRows.forEach((d, i) => {
            choseAmount += d.totalAmount;
        });
        this.setState({
            selectedRowKeys,
            selectedRows,
            choseAmount
        });
    }

    rowOnChange(value, record, index) {
        // console.log(value)
        // console.log(record)
        //           console.log(index)
        // debugger
        const self = this;
        var rows = [...this.state.rows];
        setProductUp4(value.id, index, value.taxCode, value.price).then(function (result) {
            // console.log(result);

            rows[record].amount = result.data.amount;
            rows[record].totalAmount = result.data.totalAmount;
            self.setState({rows: rows});
        });
    }

    rowOnChange2(value, record, index) {
        // console.log(record.remark);
        // console.log(value);
        // console.log(record.target.value);
        // console.log(record)
        // debugger
        var record1 = index.target.value;
        // console.log(record1)

        setProductUp5(value.id, record1, value.taxCode, value.price).then(function (result) {
            console.log(result);
            // value. = result.amount
        });
    }

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'orderTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    crStartDate: value.from,
                    crEndDate: value.end,
                }
            })
        } else if (name === 'orderTime2') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderStartDate: value.from,
                    orderEndDate: value.end,
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*移除暂存*/
    removeChange() {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择订单');
            return;
        }
        let params = this.state.selectedRowKeys;
        let self = this;
        setProductUp(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '');
                self.setState({
                    selectedRowKeys: [],
                    selectedRows: []
                }, () => {
                    self.initData();
                })
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                ...this.state.searchObj,
                name: '',
                itemNum: '',
                itemDesc: '',
                deliveryId: '',
                orderNumber: '',
                lineId: '',
                crStartDate: '',
                crEndDate: '',
                orderStartDate: '',
                orderEndDate: '',
                salesUnitId: '',
                p: 1,
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /* 翻页 刷新 */
    pageChange(page, pageSize) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                s: pageSize,
                p: page
            },
            selectedRowKeys: []
        }, function () {
            self.initData();
            // console.log(this.state);
        });
    };

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        // searchObj.categoryId = searchObj.category.length > 0 ? searchObj.category[searchObj.category.length - 1] : '';
        searchObj.orderStartDate = null;
        searchObj.orderEndDate = null;
        searchObj.crStartDate = null;
        searchObj.crEndDate = null;
        self.setState({
            loading: true
        })
        getProductList2(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false
                });
                var channelData = window.sessionStorage.getItem('cur_channelId') || '{}';
                newPurchaseUnit(channelData).then(res => { // 购货单位
                    if (res.status) {
                        var arr = new Array();
                        res.data.forEach(x => {
                            arr.push({
                                text: x.name,
                                value: x.id
                            })
                        });
                        self.setState({unitList: arr})
                    }
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    };

    /*离开当前路由时，更新store*/
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    };

    componentWillMount() {

    }

    goBack() {
        hashHistory.goBack();
    }

    changePrice = (record, value, index) => {
        var submitRows = this.state.submitRows;
        submitRows[record.id - 1].remark = value.target.value;
        this.setState({
            submitRows: submitRows
            // valueRemark:1
        });
    };

    componentDidMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }

        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    goNext() {
        // console.log(this.state);
        if (!this.state.selectedRowKeys.length) {
            openNotice('warning', '请选择行');
            return;
        }
        const selectedRows = [...this.state.selectedRows]
        if (selectedRows[0]) {
            let _id = selectedRows[0].salesUnitId;
            let _salesChannelCode = selectedRows[0].salesChannelCode;
            let _taxCode = selectedRows[0].taxCode;
            for (var i = 0; i < selectedRows.length; i++) {
                if (_id != selectedRows[i].salesUnitId) {
                    message.warning('请选择相同购货单位的订单');
                    return;
                }
                if (_salesChannelCode != selectedRows[i].salesChannelCode) {
                    message.warning('请选择相同渠道的订单');
                    return;
                }
                if (_taxCode != selectedRows[i].taxCode) {
                    message.warning('请选择相同税码的订单');
                    return;
                }
            }
        }

        let salesUnitId = this.state.selectedRows[0].salesUnitId
            , salesChannelCode = this.state.selectedRows[0].salesChannelCode
            , ids = this.state.selectedRowKeys
        ;
        let _dat = {salesUnitId, salesChannelCode, ids};
        this.goView({
            pathname: 'invoiceManagement/normalInvoice',
            state: _dat
        });
    }

    /*关联追溯行*/
    addTrace() {
        let self = this;
        if (!self.state.selectedRowKeys.length) {
            openNotice('warning', '请选择行');
            return;
        }
        var params = new Array();
        self.state.selectedRows.forEach(row => {
            params.push(row.lineId);
        });

        addTrace(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '添加成功', '');
                self.initData();
            } else {
                openNotice('error', '添加失败', (result && result.message) ? result.message : '');
            }
        });
    };

    render() {
        const {opts, key, rows, total, searchObj, selectedRowKeys, button_limits_end, loading, unitList} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'itemNum',
                    label: '物料编号',
                    text: '输入物料编号',
                    type: 'default',
                    defaultValue: searchObj.itemNum
                },
                {
                    name: 'itemDesc',
                    label: '物料名称',
                    text: '输入物料名称',
                    type: 'default',
                    defaultValue: searchObj.itemDesc
                },
                {
                    name: 'deliveryId',
                    label: '出库单号',
                    text: '输入出库单号',
                    type: 'default',
                    defaultValue: searchObj.deliveryId
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    // text: '输入购货单位',
                    type: 'select',
                    options: unitList,
                    defaultValue: searchObj.salesUnitName
                },
                {
                    name: 'orderTime',//startCreatedDate, endCreatedDate
                    label: '出库日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.crStartDate || '',
                        end: searchObj.crEndDate || ''
                    },
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.orderNumber
                },
                {
                    name: 'orderTime',//startCreatedDate, endCreatedDate
                    label: '下单日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderStartDate || '',
                        end: searchObj.orderEndDate || ''
                    },
                },
                {
                    name: 'lineId',
                    label: '发票池ID',
                    text: '输入发票池ID',
                    type: 'default',
                    defaultValue: searchObj.lineId
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 2000, y: false},
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'orderNumber'
                },
                {
                    title: '出库单号',
                    dataIndex: 'deliveryId'
                },
                {
                    title: '购货单位',
                    dataIndex: 'salesUnitName'
                },
                {
                    title: '下单日期',
                    dataIndex: 'orderDate'
                },
                {
                    title: '出库日期',
                    dataIndex: 'crDate'
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc',
                    width: '300px'
                },
                {
                    title: '物料类别',
                    dataIndex: 'itemCategory'
                },
                {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '订单类型',
                    dataIndex: 'saleType',
                    render: (text, record, index) => {
                        return (text == 'ORDER' ? '订单' : text == 'RETURN' ? '退货' : text == 'MIXED' ? '追溯' : '其他')
                    }
                },
                {
                    title: '数量',
                    dataIndex: 'qty',
                    render: (text, record, index) => (
                        <InputNumber style={{width: 50}} min={1} max={record.resQty}
                                     onChange={this.rowOnChange.bind(this, record, index)} defaultValue={text}/>
                    )
                },
                {
                    title: '单价',
                    dataIndex: 'price',
                    render: (text, record, index) => {
                        // console.log(text);
                        return (text / (1 + Number(record.taxCode / 100))).toFixed(5);
                    }
                },
                {
                    title: '金额',
                    dataIndex: 'amount'
                },
                {
                    title: '税码',
                    dataIndex: 'taxCode'
                },
                {
                    title: '总金额',
                    dataIndex: 'totalAmount',

                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    render: (text, record, index) => (
                        <Input style={{width: 50}} onChange={this.rowOnChange2.bind(this, record, index)}
                               defaultValue={text}/>
                    )
                },
                {
                    title: '发票池ID',
                    dataIndex: 'lineId'
                },
            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange
            }
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}>
                <Button key="back" onClick={this.backHandle.bind(this)}>返回</Button>
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <span>已选 {this.state.selectedRowKeys.length} 条，总金额：{this.state.choseAmount} 元</span>
                    {
                        button_limits_end.invoiceManagement_invoiceStaging_01
                        &&
                        <Button style={{position: 'absolute', bottom: 8, right: 188}}
                                onClick={this.removeChange}>移除暂存</Button>
                    }
                    {
                        button_limits_end.invoiceManagement_invoiceStaging_02
                        &&
                        <Button style={{position: 'absolute', bottom: 8, right: 80}}
                                onClick={this.addTrace}>关联追溯行</Button>
                    }
                    {
                        button_limits_end.invoiceManagement_invoiceStaging_02
                        &&
                        <Button style={{position: 'absolute', bottom: 8, right: 0}}
                                onClick={this.goNext.bind(this)}>下一步</Button>
                    }

                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

export default withRouter(invoiceStaging);


// WEBPACK FOOTER //
// ./src/routes/invoiceManagement/invoiceStaging.js